module.exports = __webpack_public_path__ + "static/media/i-question-purple.eca70362.svg";